<div class="breadcrumbs">
  <span class="title" *ngIf="!isModifica">Gestione Emergenze <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right</mat-icon> Dettaglio DPGR </span>
  <span class="title" *ngIf="isModifica">Gestione Emergenze <mat-icon style="vertical-align: middle;">
      keyboard_arrow_right</mat-icon> Modifica DPGR </span>
</div>
<hr>

<div class="titolo flex-display">
  <div class="flex-display">
    <button mat-stroked-button class="pers" (click)="onNavigate('lista-eventi')">
      <mat-icon style="vertical-align: middle;">keyboard_arrow_left</mat-icon>
    </button>

    <span class="h1 upp">Dettaglio DPGR</span>
  </div>


  <div class="flex-row">
    <button mat-stroked-button color='basic' class="pers2 mleft" *ngIf="showEmerNonRicButton && isDettaglio" (click)="openEmergNonRicDialog()">
      EMERGENZA NON RICONOSCIUTA
    </button>
    <button mat-stroked-button color='basic' class="pers2 mleft" *ngIf="((isDettaglio && isModifica) || !isDettaglio) && showInvADipPCButton==true" (click)="openInvioDipartimentoPCDialog()">
      INVIA A DIPARTIMENTO P.C.
    </button>
    <button mat-stroked-button *ngIf="(isModifica)" color='basic' class="pers2 mleft"
      (click)="onNavigate('enti-delegati')">
      ENTI DELEGATI
    </button>
    <button mat-stroked-button *ngIf="(isDettaglio)" color='basic' class="pers2 mleft"
      (click)="onNavigate('template-list', form.controls.denominazione.value)">
      TEMPLATE
    </button>
    <button mat-flat-button color='accent' class="pers3 mleft" *ngIf="(isDettaglio && isModifica) || !isDettaglio"
      (click)="onSaveEvent()">
      SALVA MODIFICHE
    </button>
  </div>
</div>



<div class="pers titles">
  <span class="title"> DATI DPGR </span>
</div>


<form class="flex-form" [formGroup]="form">


<div class="flex-row detail">
<div>
  <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill">
    <mat-label class="big">DPGR *</mat-label>
    <input matInput [formControlName]="'dpgr'" >
  </mat-form-field>
  <mat-error *ngIf="this.form.controls.dpgr.errors && this.form.controls.dpgr.touched">
    <mat-error *ngIf="this.form.controls.dpgr.errors.required">Campo obbligatorio
    </mat-error>
    <mat-error *ngIf="this.form.controls.dpgr.errors.maxlength">Il numero massimo di
      caratteri consentiti è 10</mat-error>
  </mat-error>
</div>
<div>
  <mat-form-field class="mat-input-wrapper"  color="accent" appearance="fill">
    <mat-label class="big">Data DPGR *</mat-label>
    <input matInput [formControlName]="'dataEvento'" [matDatepicker]="picker1">
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
  </mat-form-field>
  <mat-error *ngIf="this.form.controls.dataEvento.errors && this.form.controls.dataEvento.touched">
  <mat-error *ngIf="this.form.controls.dataEvento.errors.required">Campo obbligatorio
  </mat-error>
</mat-error>
</div>
<div>
  <mat-form-field class="mat-input-wrapper hidden">
    <input hidden matInput [formControlName]="'codiceEvento'" >
  </mat-form-field>
</div>
</div>

  <div class="detail">
      <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill">
        <mat-label class="big">Denominazione *</mat-label>
        <input matInput [formControlName]="'denominazione'" >
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.denominazione.errors && this.form.controls.denominazione.touched">
        <mat-error *ngIf="this.form.controls.denominazione.errors.required">Campo obbligatorio
        </mat-error>
        <mat-error *ngIf="this.form.controls.denominazione.errors.maxlength">Il numero massimo
          di caratteri consentiti è 100</mat-error>
      </mat-error>
</div>

<div class="detail">
      <mat-form-field id='descrizione' class="mat-input-wrapper" color="accent" appearance="fill">
        <mat-label class="big">Descrizione </mat-label>
        <textarea matInput  [formControlName]="'descrizione'" ></textarea>
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.descrizione.errors">
        <mat-error *ngIf="this.form.controls.descrizione.errors.maxlength">Il numero massimo di
          caratteri consentiti è 2000</mat-error>
      </mat-error>
    </div>

    <div class="flex-row detail">
      <div class="detail">
        <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill">
          <mat-label class="big">Data inizio evento </mat-label>
          <input matInput [formControlName]="'dataInizioEvento'"  [matDatepicker]="picker2">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
        <mat-error *ngIf="this.form.controls.dataEvento.errors && this.form.controls.dataEvento.touched">
        </mat-error>
      </div>
      <div class="detail">
        <mat-form-field class="mat-input-wrapper" color="accent" appearance="fill">
          <mat-label class="big">Data fine evento </mat-label>
          <input matInput [formControlName]="'dataFineEvento'"  [matDatepicker]="picker3">
          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
        </mat-form-field>
        <mat-error *ngIf="this.form.controls.dataEvento.errors && this.form.controls.dataEvento.touched">
        </mat-error>
      </div>
      <div>
        <mat-form-field class="mat-input-wrapper hidden">
          <input hidden matInput [formControlName]="'codiceEvento'">
        </mat-form-field>
      </div>
    </div>

    <div class="flex-row" *ngIf="isDettaglio">
      <mat-form-field [ngClass]="{'mat-change':this.isModifica}" color="accent" appearance="fill">
        <mat-label class="big">Stato</mat-label>

        <mat-select [formControlName]="'stato'">
          <mat-option value=""></mat-option>
          <mat-option value="BOZ">In bozza</mat-option>
          <mat-option value="RAC">Raccolta Dati</mat-option>
          <mat-option value="ATT">In attesa di emergenza</mat-option>
          <mat-option value="POS">Post Emergenza</mat-option>
          <mat-option value="RDP">Raccolta Dati</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-error *ngIf="this.form.controls.stato.errors ">
        <mat-error *ngIf="this.form.controls.stato.errors.required">Campo obbligatorio
        </mat-error>
        <mat-error *ngIf="this.form.controls.stato.errors.maxlength">Il numero massimo di
          caratteri consentiti è 10</mat-error>
      </mat-error>


      <mat-form-field [ngClass]="{'mat-change':this.isModifica}" color="accent" appearance="fill">
        <mat-label class="big">Utente ultima modifica </mat-label>
        <input matInput [formControlName]="'utenteUltimaMod'" >
      </mat-form-field>


      <mat-form-field [ngClass]="{'mat-change':this.isModifica}" color="accent" appearance="fill">
        <mat-label class="big">Data ultima modifica </mat-label>
        <input matInput [formControlName]="'dataUltimaMod'" [matDatepicker]="picker4">
        <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
        <mat-datepicker #picker4></mat-datepicker>
      </mat-form-field>
    </div>
</form>
